import { type HttpClient } from '../useHttpClient';

export type PostUnitInsightLlmExperimentalChatMessageStreamChunk = {
  type: 'chat-message-chunk';
  data: { text: string };
};

export const postUnitInsightLlmExperimentalChatMessage =
  (httpClient: HttpClient) =>
  async ({
    message,
    model,
    systemPrompt,
    fileUrls,
  }: {
    message: string;
    model: string;
    systemPrompt: string;
    fileUrls: string[];
  }) => {
    const response =
      await httpClient.restApiKpis<PostUnitInsightLlmExperimentalChatMessageStreamChunk>(
        '/kpis/llm/experimental-chat-messages',
        {
          method: 'POST',
          body: JSON.stringify({
            message,
            model,
            systemPrompt,
            fileUrls,
          }),
        }
      );

    return response;
  };
